<template>
  <div>
    <v-dialog v-model="dialog.form" 
      persistent
      width="500">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 white--text light-green lighten-2">
          {{ form.id.length > 0 ? 'Ubah' : 'Tambah' }} Fasilitas
        </v-card-title>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-form class="pt-5 pb-0">
              <ValidationProvider name="Nama Fasilitas" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Nama Fasilitas"
                  prepend-inner-icon="mdi-timeline-check-outline"
                  :color="style.primary"
                  v-model="form.name"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Pilih Status" rules="required" v-slot="{ errors }">
                <v-select
                  dense
                  outlined
                  single-line
                  label="Pilih Status"
                  :color="style.primary"
                  prepend-inner-icon="mdi-list-status"
                  :items="[
                    {
                      label: 'Semua',
                      value: 'all'
                    },
                    {
                      label: 'Umum',
                      value: 'public'
                    },
                    {
                      label: 'Pribadi',
                      value: 'private'
                    }
                  ]"
                  item-value="value"
                  item-text="label"
                  item-color="light-green lighten-2"
                  v-model="form.type"
                  :error-messages="errors"
                  require>
                  <template v-slot:append>
                    <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-form>
          </ValidationObserver>
          <v-alert 
            class="mx-10 mt-10"
            type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-divider class="mx-4 my-2"/>
        <v-card-actions class="pa-5">
          <v-spacer/>
          <v-btn
            small
            :color="style.primary"
            elevation="3"
            class="text-capitalize white--text mx-1"
            :loading="process.form"
            :disabled="process.form"
            @click="save">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn
            small
            outlined
            class="text-capitalize red--text mx-1"
            :disabled="process.form"
            @click="reset(); $refs.observer.reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete" 
      persistent
      width="400">
      <v-card class="pa-5">
        <v-card-text>
          Apakah anda yakin menghapus
          <span class="font-weight-bold">
            {{ detail.facility_name }}
          </span>
          ?
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            small
            color="red"
            elevation="3"
            class="text-capitalize white--text mx-1"
            :loading="process.form"
            :disabled="process.form"
            @click="deletes">
            <v-icon small class="mr-1">mdi-trash-can-outline</v-icon>
            Ya, hapus
          </v-btn>
          <v-btn
            small
            outlined
            class="text-capitalize red--text mx-1"
            :disabled="process.form"
            @click="detail = {}; dialog.delete = false;">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="sorting.show"
      class="hidden-md-and-up"
      fullscreen 
      hide-overlay 
      transition="dialog-bottom-transition">
      <v-card 
        flat
        color="#f9f9f9">
        <v-card-text class="py-0 pl-0 pr-0">
          <v-toolbar dark :color="style.primary">
            <v-btn icon dark @click="sorting.show = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Filter</v-toolbar-title>
            <div class="flex-grow-1"></div>
          </v-toolbar>
          <v-card-text class="text-second text-left pb-0" style="font-size: 12px;">
            Anda bisa menambahkan fasilitas baik untuk umum atau pribadi.
          </v-card-text>
          <v-card-text class="text-third text-left" style="font-size: 12px;">
            Silahkan pilih tipe :
          </v-card-text>
          <v-list dense class="pa-0 border-item">
            <v-list-item-group
              v-model="selected.menu"
              no-action
              active-class="white--text">
              <template v-for="(item, index) in menu">
                <v-list-item :key="index"
                  :class="{
                    'actived': selected.menu === index
                  }"
                  @click="sorting.show = false">
                  <template v-slot:default="{ active, toggle }">
                    <v-list-item-content class="pa-0">
                      <v-list-item-title class="text-left text-second caption">
                        {{ item.label }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
                <v-divider/>
              </template>
            </v-list-item-group>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <v-row>
      <v-col cols="12" class="py-0">
        <v-card flat min-height="800">
          <v-row>
            <v-col cols="12" md="3" class="text-center pa-0 hidden-sm-and-down">
              <div class="pa-0" style="width: 100%; min-height: 700px;">
                <v-card-text class="py-0 pl-0 pr-0">
                  <v-card-text class="text-second text-left pb-0" style="font-size: 12px;">
                    Anda bisa menambahkan fasilitas baik untuk umum atau pribadi.
                  </v-card-text>
                  <v-card-text class="text-third text-left" style="font-size: 12px;">
                    Silahkan pilih tipe :
                  </v-card-text>

                  <v-list dense class="pa-0 border-item">
                    <v-list-item-group
                      v-model="selected.menu"
                      no-action
                      active-class="white--text">
                      <template v-for="(item, index) in menu">
                        <v-list-item :key="index"
                          :class="{
                            'actived': selected.menu === index
                          }">
                          <template v-slot:default="{ active, toggle }">
                            <v-list-item-content class="pa-0">
                              <v-list-item-title class="text-left text-second caption">
                                {{ item.label }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </v-list-item>
                        <v-divider/>
                      </template>
                    </v-list-item-group>
                  </v-list>
                </v-card-text>
              </div>
              <div class="pa-0">
                <v-divider vertical />
              </div>
            </v-col>
            <v-col cols="12" md="9" class="pa-0">
              <v-card-text class="subtitle-2 py-5">
                Fasilitas
              </v-card-text>
              <v-divider/>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="8" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pb-0':'py-0'">
                    <v-btn v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')"
                      :color="style.primary"
                      elevation="3"
                      class="text-capitalize white--text"
                      @click="reset()">
                      <v-icon small class="mr-1">mdi-plus</v-icon>
                      Fasilitas
                    </v-btn>
                  </v-col>
                  <v-col cols="12"  md="4" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm'? 'pb-0':'py-0'">
                    <v-text-field
                      outlined
                      dense
                      :hide-details="true"
                      placeholder="Cari Fasilitas . . ."
                      clearable
                      :color="style.primary"
                      v-model="filter.title"
                      @click:clear="filter.title = ''; fetch();"
                      v-on:keyup.enter="fetch()"
                      prepend-inner-icon="mdi-magnify">
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider class="mx-4"/>
              <v-card-text class="py-0" style="min-height: 550px;">
                <v-skeleton-loader
                  :loading="process.run"
                  transition="scale-transition"
                  :tile="false"
                  type="table-tbody">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead v-if="!process.run && list.length > 0">
                        <tr>
                          <th class="text-left pl-0">Nama Fasilitas</th>
                          <th class="text-left">Status</th>
                          <th class="text-left"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr 
                          v-for="(item, index) in list" 
                          :key="index">
                          <td class="text-second pl-0">
                            {{ item.facility_name }}
                          </td>
                          <td class="text-second text-capitalize">
                            {{ item.facility_type === 'all' ? 'Semua' : item.facility_type === 'public' ? 'Umum' : 'Pribadi' }}
                          </td>
                          <td class="text-right pr-0">
                            <v-btn
                              small
                              text
                              min-width="30"
                              class="text-capitalize green--text pa-0 mr-1"
                              @click="reset(item)">
                              <v-icon small>mdi-pencil-outline</v-icon>
                            </v-btn>
                            <v-btn
                              small
                              text
                              min-width="30"
                              class="text-capitalize red--text pa-0 mr-1"
                              @click="detail = item; dialog.delete = true;">
                              <v-icon small>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-skeleton-loader>
                <div class="d-flex align-center text-center text--secondary my-12 py-12" style="min-height: 500px;" v-if="!process.run && pagination.total_page < 1">
                  <v-img 
                    class="my-12"
                    contain
                    width="200"
                    height="200"
                    :src="require('../../assets/404/404.svg')">
                  </v-img>
                </div>
                <v-divider/>
              </v-card-text>
              <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'pt-0':''">
                <v-row justify="end" align="center" v-if="pagination.total_page > 1">
                  <v-col cols="12" md="2" class="d-flex align-center justify-end">
                    <v-btn
                      :color="style.primary"
                      :disabled="pagination.current === 1"
                      elevation="3"
                      min-width="36"
                      class="text-capitalize white--text px-0 mr-3"
                      @click="selected.pagination = 1">
                      <v-icon>mdi-chevron-double-left</v-icon>
                    </v-btn>
                    <v-btn
                      color="#263238"
                      :disabled="pagination.current < 2"
                      elevation="3"
                      min-width="36"
                      class="text-capitalize white--text px-0"
                      @click="selected.pagination = selected.pagination-1">
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    <div class="mx-5" style="width: 75px;">
                      <v-autocomplete
                        v-model="selected.pagination"
                        :items="pagination.detail"
                        color="#263238"
                        auto-select-first
                        outlined
                        dense
                        single-line
                        hide-details
                        hide-selected>
                        <template v-slot:selection="{ item }">
                          {{ item }}
                        </template>
                      </v-autocomplete>
                    </div>
                    <v-btn
                      color="#263238"
                      elevation="3"
                      min-width="36"
                      class="text-capitalize white--text px-0"
                      :disabled="pagination.current >= pagination.total_page"
                      @click="selected.pagination = selected.pagination+1">
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                    <v-btn
                      :color="style.primary"
                      :disabled="pagination.current === pagination.total_page"
                      elevation="3"
                      min-width="36"
                      class="text-capitalize white--text px-0 ml-3"
                      @click="selected.pagination = pagination.total_page">
                      <v-icon>mdi-chevron-double-right</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
      
    <div class="v-add-position hidden-md-and-up">
      <v-fab-transition>
        <v-btn 
          class="v-add"
          :color="style.primary"
          rounded
          fixed
          bottom
          right
          fab
          elevation="0"
          @click="sorting.show = true">
          <v-icon color="white">mdi-filter</v-icon>
        </v-btn>
      </v-fab-transition>
    </div>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  export default {
    data () {
      return {
        dialog: {
          form: false,
          delete: false
        },
        sorting: {
          show: false
        },
        selected: {
          menu: 0,
          pagination: 1
        },
        menu: [
          {
            label: "Semua",
            value: "all"
          },
          {
            label: "Umum",
            value: "public"
          },
          {
            label: "Pribadi",
            value: "private"
          }
        ],
        filter: {
          title: ''
        },
        page: 1,
        list: [],
        pagination: {},
        detail: {},
        form: {
          id: '',
          name: '',
          type: ''
        },
        process: {
          run: false,
          form: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    components: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      'selected.menu': function(val) {
        this.filter.url = this.menu[val].value
        
        this.fetch()
      },
      'selected.pagination': function(val) {
        this.fetch(val)
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch(p) {
        this.process.run = true

        let params = {
          page: p,
          limit: 10,
          type: this.menu[this.selected.menu].value,
          filter: [
            {
              type: 'string',
              field: 'facility_name',
              value: this.filter.title,
              comparison: '<>'
            }
          ]
        }

        await get(`project/facility/get-list`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            this.list = res.data.results
            this.pagination = res.data.pagination
            this.pagination.current = parseInt(this.pagination.current)
          }
        })
      },
      reset(item) {
        this.dialog.form = !this.dialog.form ? true : false

        this.form = { 
          id: item !== undefined ? item.facility_id : '',
          name: item !== undefined ? item.facility_name : '',
          type: item !== undefined ? item.facility_type : ''
        }

        this.process.form = false

        this.error.message = ''
      },
      async save() {
        this.error.message = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          if (this.form.id.length < 1) {
            this.creates()
          } else {
            this.updates()
          }
        }
      },
      async creates() {
        this.error.message = ''
        this.process.form = true
        await post(`auth/project/facility/create`, {
          data: {
            name: this.form.name,
            type: this.form.type
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.reset()
            this.fetch()
          } else {
            this.process.form = false
            this.error.message = res.msg
          }
        })
      },
      async updates() {
        this.error.message = ''
        this.process.form = true
        await post(`auth/project/facility/update`, {
          data: {
            id: this.form.id,
            name: this.form.name,
            type: this.form.type
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.reset()
            this.fetch()
          } else {
            this.process.form = false
            this.error.message = res.msg
          }
        })
      },
      async deletes() {
        this.error.message = ''
        this.process.form = true
        await post(`auth/project/facility/delete`, {
          data: {
            id: this.detail.facility_id
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.dialog.delete = false
            this.detail = {}
            this.process.form = false
            this.fetch()
          } else {
            this.process.form = false
            this.error.message = res.msg
          }
        })
      }
    }
  }
</script>

<style>
.actived {
  background: #f3f3f3;
}
</style>